import * as color from 'modules/common/theme/color';
import styled, { css } from 'styled-components';

import { getStyle } from 'modules/v2/editor/utils';

const Panel = styled.div`
  transform-origin: top;
  display: flex;
  flex-direction: column;
  background-color: ${color.neutral100};
  border-left: 1px solid ${color.neutral200};

  ${({ layout }) => {
    const { height } = getStyle(layout);

    return css`
      min-height: ${height};
      padding: 24px 24px 0px 24px;
    `;
  }}
`;

const Wrapper = styled.div`
  .textfield-wrapper {
    border: 1px dotted grey;
  }

  .textfield-wrapper {
    overflow: hidden;

    ul {
      padding-inline-start: 25px;
    }

    .content-title,
    .title {
      margin: 0 !important;
    }
  }
`;

const Element = styled.div`
  ${({ showGuides, element, isEmpty }) => {
    const {
      order,
      margin,
      padding,
      lineHeight,
      fontFamily,
      fontSize,
      fontWeight,
      textAlign,
      color,
      border,
    } = getStyle(element);

    return css`
      color: ${!isEmpty ? color : 'rgb(145, 151, 163)'};
      order: ${order};
      font-size: ${fontSize};
      margin: ${margin};
      text-align: ${textAlign};
      line-height: ${lineHeight};
      font-family: ${fontFamily};
      font-weight: ${fontWeight};
      padding: ${padding};
      border: ${border};

      ${!showGuides &&
      `
          border-color: transparent;
        `}
    `;
  }}
`;

export default {
  Wrapper,
  Panel,
  Element,
};
